module.exports = __webpack_public_path__ + "static/media/airtel.032b6971.png";